/*  */
import './Footer.css'
import {Button} from "../Button/Button.jsx";
import {usePanelStatus} from "../HorizontalScroll/panelStatus.js";
import {ORDER_URL} from "../Header/Header.jsx";

// статус панелі з контексту → клас-фаза інтро
const STATUS_CLASS = {
	after: 'is-armed',   // ще не дійшли: елементи на стартових позиціях, сховані
	active: 'is-in',     // доведена: програти етапи входу
	before: 'is-out',    // (для footer не використовується — він останній)
	static: null,        // без горизонтального скролу: просто показуємо контент
};

const Footer = () => {
	const status = usePanelStatus();
	const classes = ['footer', STATUS_CLASS[status]].filter(Boolean).join(' ');

	return (
		<footer className={classes} id="contacts">
			<img src='/images/footer.webp' className="footer__img" alt='Footer Pack'/>
			<div className="footer__text">
				<h3 className='footer__text-title'>Зацікавили пропозиції?</h3>
				<span className='footer__text-subtitle'>Переходьте в чат-бот</span>
				<Button
					variant='secondary'
					size='lg'
					as='a'
					href={ORDER_URL}
					target='_blank'
					rel='noopener noreferrer'
					className='footer__text-btn'
					analyticsEvent="cta_click"
					analyticsParams={{location: "footer", label: "order"}}
				>
					Замовити
				</Button>
			</div>

			<div className="footer__black">
				<div className="footer__bottom">
					<div className="footer__black-wrapper">
						<h4>Телефон</h4>
						<a className='footer__black-phone' href="tel: 0800601188">0 800 60 11 88</a>
						<h4>Адреса</h4>
						<a className='footer__black-address' href="https://maps.app.goo.gl/aAjcE45mLHbxvXMx9?g_st=ic?" rel='noopener noreferrer' target='_blank'>м. Київ, вул. Сімʼї Кульженків, 8</a>
						<p>Пн-Пт: 08:00-18:00</p>
						<p>Сб: 10:00-15:00</p>
					</div>
					<span className='footer__black-copyright'>2026. Всі права захищені</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;